import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { typedQueryClient } from "hooks";
import { DayplannerKeys } from "modules/Dayplanner/queryKeys";
import { ApiInstance } from "utils/Api";

type AssignMutationPayload = {
  appointment_id: number;
  user_id: number;
  order: number;
};

export const useAssignMutation = () => {
  const { selectedLocation } = useSelectedLocation();

  const mutation = useMutation({
    mutationFn: async (data: AssignMutationPayload) => ApiInstance.post("/dayplanner/appointments/assign", data),
    onMutate: async data => {
      if (!selectedLocation?.id) throw new Error("invalid location");
      const appointments = typedQueryClient.getQueryData(DayplannerKeys.appointments);

      const updatedAppointments = appointments?.map(app => {
        if (app.id === data.appointment_id) return { ...app, assigned_mechanic: data.user_id, assigned_mechanic_order: data.order };

        if (app.assigned_mechanic === data.user_id && Number(app.assigned_mechanic_order) >= data.order)
          return { ...app, assigned_mechanic_order: Number(app.assigned_mechanic_order) + 1 };

        return app;
      });

      typedQueryClient.setQueryData(DayplannerKeys.appointments, updatedAppointments ?? []);

      return appointments;
    },
    onError: (error, _, appointments) => {
      toast.error(error.message);
      if (selectedLocation?.id) typedQueryClient.setQueryData(DayplannerKeys.appointments, appointments ?? []);
    }
  });

  return mutation.mutate;
};
